import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import {
    CageFrameCorner,
    MeshRoll,
    LanaiRoof,
    ScreenDoor,
    CondoPanel,
    StormCage,
    ZBar,
} from "@/components/ui/icons/A1Icons";

/**
 * Service card on dark surface. Cyan A1-Screening-specific icon, uppercase
 * title, white-grey body, cyan "Learn more" arrow.
 *
 * Feb 2026 — switched from Lucide stock icons (Waves, Wind, DoorOpen, Cloud)
 * to the A1 screen-enclosure icon kit so each service card visually
 * identifies the actual trade.
 */
const ICONS = {
    "pool-cage-repair": CageFrameCorner,
    "pool-rescreening": MeshRoll,
    "structural-pool-cage-repair": ZBar,
    "lanai-screen-repair": LanaiRoof,
    "screen-door-repair": ScreenDoor,
    "storm-screen-repair": StormCage,
    "condo-screen-repair": CondoPanel,
};

export default function ServiceCard({ service }) {
    const Icon = ICONS[service.slug] || CageFrameCorner;
    return (
        <Link
            to={`/services/${service.slug}`}
            className="a1-card a1-card-link no-underline flex flex-col gap-4 h-full group"
            data-testid={`service-card-${service.slug}`}
        >
            <div className="a1-icon-wrap-lg group-hover:scale-105 transition-transform">
                <Icon size={26} strokeWidth={1.8} />
            </div>
            <h3
                className="text-lg md:text-xl leading-tight"
                style={{ color: "var(--color-text)" }}
            >
                {service.name}
            </h3>
            <p
                className="flex-1 text-[15px] leading-relaxed"
                style={{ color: "var(--color-text-muted)" }}
            >
                {service.hero_summary}
            </p>
            <span className="a1-btn-ghost mt-1">
                Learn more <ArrowRight size={14} className="group-hover:translate-x-0.5 transition-transform" />
            </span>
        </Link>
    );
}
